import { BoldText } from '@capsicum/common-web';
import React from 'react';
import { type IntlConfig } from 'react-intl';

type RichTextConfig = IntlConfig['defaultRichTextElements'];

export const RICH_TAGS = {
	bold: chunks => <BoldText>{chunks as Array<React.ReactNode>}</BoldText>
} satisfies RichTextConfig;
